import { DefaultProps } from '@app/Types/global.interfaces';
import { ReactNode } from 'react';

export enum AccordionThemes {
  Primary = 'primary',
}

export interface AccordionTypeProps extends DefaultProps {
  active: boolean;
  classNameHeader?: string;
  title: string | ReactNode;
  theme?: AccordionThemes;
  noLazy?: boolean;
  lazy?: boolean;
  content: ReactNode;
  ElementIdTab?: string;
  setActive: () => void;
}
